import { createMuiTheme } from 'material-ui/styles';
// import blueGrey from 'material-ui/colors/blueGrey';
import red from 'material-ui/colors/red';
import ColorPalette from '../components/styling/ColorPalette';

// All the following keys are optional.
// We try our best to provide a great default value.
const theme = createMuiTheme({
  palette: {
    primary: {
      light: ColorPalette.primaryLight,
      main: ColorPalette.primary,
      dark: ColorPalette.primaryDark,
      contrastText: '#fff',
    },
    secondary: {
      light: ColorPalette.secondaryLight,
      main: ColorPalette.secondary,
      dark: ColorPalette.secondaryDark,
      contrastText: '#fff',
    },
    error: { main: '#ff4d52' },
    // Used by `getContrastText()` to maximize the contrast between the background and
    // the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
});

export default theme;



// WEBPACK FOOTER //
// ./src/containers/AppTheme.js